import {
    GET_ORDER_REQUEST,
    GET_ORDER_SUCCESS,
    GET_ORDER_FAILURE,
    CREATE_ORDER_REQUEST,
    CREATE_ORDER_SUCCESS,
    CREATE_ORDER_FAILURE,
    UPDATE_ORDER_REQUEST,
    UPDATE_ORDER_SUCCESS,
    UPDATE_ORDER_FAILURE,
    UPDATE_PRODUCT_SNAPSHOT_REQUEST,
    UPDATE_PRODUCT_SNAPSHOT_SUCCESS,
    UPDATE_PRODUCT_SNAPSHOT_FAILURE,
    CREATE_PRODUCT_SNAPSHOT_FAILURE,
    CREATE_PRODUCT_SNAPSHOT_SUCCESS,
    CREATE_PRODUCT_SNAPSHOT_REQUEST,
    SEARCH_ORDER_FAILURE,
    SEARCH_ORDER_SUCCESS,
    SEARCH_ORDER_REQUEST,
    RESET_ORDER_STATE,
    UPDATE_ORDER_STATUS_FAILURE,
    UPDATE_ORDER_STATUS_SUCCESS,
    UPDATE_ORDER_STATUS_REQUEST, DELETE_PRODUCT_SNAPSHOT_SUCCESS,
} from '../actions/order-actions';

const initialState = {
    order: null,
    loading: false,
    error: null,
    searchResults: null
};

const orderReducer = (state = initialState, action) => {
    switch (action.type) {
        // Order retrieval and creation
        case GET_ORDER_REQUEST:
        case CREATE_ORDER_REQUEST:
        case UPDATE_ORDER_REQUEST:
            return {...state, loading: true, error: null};
        case GET_ORDER_SUCCESS:
            return {...state, loading: false, order: action.payload};
        case CREATE_ORDER_SUCCESS:
            return {...state, loading: false, order: action.payload};
        case UPDATE_ORDER_SUCCESS:
            return {...state, loading: false, order: action.payload};
        case GET_ORDER_FAILURE:
        case CREATE_ORDER_FAILURE:
        case UPDATE_ORDER_FAILURE:
            return {...state, loading: false, error: action.payload};
        case UPDATE_ORDER_STATUS_REQUEST:
            return {...state, loading: true, error: null};
        case UPDATE_ORDER_STATUS_SUCCESS:
            return {...state, loading: false, order: action.payload};
        case UPDATE_ORDER_STATUS_FAILURE:
            return {...state, loading: false, error: action.payload};
        case CREATE_PRODUCT_SNAPSHOT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                productSnapshotCreationStatus: 'loading',
            };
        case CREATE_PRODUCT_SNAPSHOT_SUCCESS:
            return {
                ...state,
                loading: false,
                order: action.payload, // updated order from backend
                productSnapshotCreationStatus: 'success',
            };
        case CREATE_PRODUCT_SNAPSHOT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                productSnapshotCreationStatus: 'failure',
            };
        // Update Product Snapshot (update loading and error state)
        case UPDATE_PRODUCT_SNAPSHOT_REQUEST:
            return {...state, loading: true, error: null};
        case UPDATE_PRODUCT_SNAPSHOT_SUCCESS:
            // As the endpoint returns no content, we simply set loading to false.
            return {
                ...state,
                loading: false,
                order: action.payload, // updated order from backend
            };
        case UPDATE_PRODUCT_SNAPSHOT_FAILURE:
            return {...state, loading: false, error: action.payload};
        case SEARCH_ORDER_REQUEST:
            return {...state, loading: true, error: null};
        case SEARCH_ORDER_SUCCESS:
            return {...state, loading: false, searchResults: action.payload};
        case SEARCH_ORDER_FAILURE:
            return {...state, loading: false, error: action.payload};
        case RESET_ORDER_STATE:
            return {...state, order: null};
        case DELETE_PRODUCT_SNAPSHOT_SUCCESS:
            return {
                ...state,
                order: {
                    ...state.order,
                    productSnapshots: state.order.productSnapshots.filter(
                        (snap) => snap.id.snapshotId !== action.payload.snapshotId
                    ),
                },
            };
        default:
            return state;
    }
};

export default orderReducer;
